<template>
  <div>
    <div v-if="announcement" :class="$store.state.shop.id !== 6 ? 'envelop' : 'envelop-6'" @click="showDialog">
      <van-icon v-if="$store.state.shop.id !== 6" name="bullhorn-o"  size="24" />
      <van-icon v-if="$store.state.shop.id === 6" name="/static/images/6/announcement.png"  size="90" />
      <!--    <img src="/static/images/default/yue.png"-->
      <!--         style="width: 50%;position: absolute;left: 50%;top: 50%;transform: translate(-50%,-50%)">-->
    </div>

    <van-dialog  v-model="show" :allow-html="true" :title="announcement.title" confirm-button-text="已读" get-container="#app"
                 @confirm="onConfirm">
      <div class="margin-lr-sm" v-html="announcement.content" style="max-height: 50vh;overflow-y: scroll;"></div>
    </van-dialog>
  </div>

</template>
<script>
import {getAnnouncement} from "@/api/announcement";

export default {
  name: "announcement",
  props: {},
  components: {},
  data() {
    return {
      localStorage: window.localStorage,
      show: false,
      announcement: null
    }
  },
  methods: {
    showDialog(){
      this.show = true
    },
    onConfirm() {
      localStorage.setItem('announcement:' + this.announcement.shopId, this.announcement.updateTime)
    },
    loadData() {
      getAnnouncement().then(res => {
        const data = res.data;
        if (data.code === 0) {
          this.announcement = data.announcement;
          if (this.announcement && this.announcement.content) {
            if (localStorage.getItem('announcement:' + this.announcement.shopId) !== String(this.announcement.updateTime)) {
              this.show = true;
            }
          }
        }
      })
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>
<style lang="less" scoped>
.envelop {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: fixed;
  left: 1%;
  bottom: 2%;
  background: #fff;
  box-shadow: 0px 3px 6px rgba(142, 142, 142, 0.16);
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.envelop-6 {
  position: fixed;
  top: 7%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
}
</style>
